import { Base } from "./Base";
import { ServiceCatalog } from "./ServiceCatalog";
import { ICountry, IServiceCatalog, IServiceProvider } from "./shared/types";

export class ServiceProvider extends Base implements IServiceProvider {
  HalloId: string; //system generated surrogate key.
  Code: string; //application defined key, define once and never changed
  Name: string; //display name, such as nickname or short name
  Catchword: string;  //a message or slogan for this provider
  Avatar: string;
  CoverImage: string;
  Region: ICountry;
  Email: string;
  Mobile: string;
  QRCode: string;
  Url: string;

  ServiceCatalogs?: ServiceCatalog[] = [];

  UserToken?: string;
  
  protected _basePropertyNames = [
      'HalloId', 'Code','Name', 'Catchword', 'Avatar', 'CoverImage', 
      'Region', 'Email', 'Mobile', 'QRCode'
  ];

  protected _propertyNames = [
      ...this._basePropertyNames,
      'Url', 'ServiceCatalogs'
  ];

  constructor(provider?:IServiceProvider) {
      super();
      if (provider) {
          this.Properties = provider;
      }
  }
  
  get Properties() : IServiceProvider {
    return <IServiceProvider> this.getProperties();
  }

  set Properties(provider:IServiceProvider) {
      for (let p in provider) {
          if (p=='ServiceCatalogs') {
              this.ServiceCatalogs = provider.ServiceCatalogs.map((isc:IServiceCatalog) => {
                let sc = new ServiceCatalog(isc);
                sc.ServiceProvider = this.Properties;
                return sc;
              });
          } else if (this._propertyNames.indexOf(p) != -1) {
              this[p] = provider[p];
          }
      }
  }
}
